import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=f2b8166a&scoped=true&"
import script from "@/service/orderdetailservice.js?vue&type=script&charset=utf-8&lang=js&"
export * from "@/service/orderdetailservice.js?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=f2b8166a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b8166a",
  null
  
)

export default component.exports